// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".success{background-color:#1a1a1a;width:100%;position:absolute;bottom:0;z-index:999;display:flex;flex-direction:column;border-radius:24px 24px 0px 0px}.success__msg{background-color:#4ac374;display:flex;justify-content:center;align-items:center;border-radius:12px}.success__msg__text{font-size:2.4rem;color:#111;font-weight:600;margin:7px 16px 0}.success__image{margin:60px auto}", ""]);
// Exports
module.exports = exports;
